module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Prediction Timeline  (Traffic)","prediction_timeline_tooltip1":"This timeline predicts your future number of visitors based on numerous variables.","Mon":"Mon","Tue":"Tue","Wed":"Wed","Thu":"Thu","Fri":"Fri","Sat":"Sat","Sun":"Sun","Current":"Current","Prediction":"Prediction","Traffic":"Traffic"}}')
  delete Component.options._Ctor
}
